export default __webpack_public_path__ + "static/media/img3.17841e09.jpg";